module.exports = __webpack_public_path__ + "static/2front-guerilla-1-d3e4d29658f0561f3aa7cc9f701afe3d.png";